import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { Link } from '@material-ui/core';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { Elements, ElementsConsumer } from '@stripe/react-stripe-js';
import CheckoutForm from './CheckoutForm';


import { withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import MuiDialogTitle from '@material-ui/core/DialogTitle';

import { removeFromCart } from '../actions'

const DialogTitle = withStyles(theme => ({
	root: {
		//borderBottom: `1px solid ${theme.palette.divider}`,
		margin: 0,
		padding: theme.spacing.unit * 2,
	},
	closeButton: {
		position: 'absolute',
		right: theme.spacing.unit,
		top: theme.spacing.unit,
		color: theme.palette.grey[500],
	},
}))(props => {
	const { children, classes, onClose } = props;
	return (
		<MuiDialogTitle disableTypography className={classes.root}>
			<Typography variant="h6">{children}</Typography>
			{onClose ? (
				<IconButton aria-label="Close" className={classes.closeButton} onClick={onClose}>
					<CloseIcon />
				</IconButton>
			) : null}
		</MuiDialogTitle>
	);
});

export default function ShoppingCart() {
	const cart = useSelector(state => state.app.cart)
	const dispatch = useDispatch();

	const [voucher, setVoucher] = useState();
	const [voucherAmount, setVoucherAmount] = useState(0);
	const [checkoutOpened, setCheckoutOpened] = useState(false);
	//const [processingOpened, setProcessingOpened] = useState(false);

	let handleValidateVoucher = async () => {
		let response = await fetch(global.serverUrl + '/voucher?voucher=' + voucher, {
			method: "POST",
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({ cart: cart })
		});
		let data = await response.json();
		if (data.amount === 10020) {
			//$1 on digital posters and $5 on paper posters
			let amount = cart.reduce((prev, curr) => (curr.format === 'digital' ? 1 : 5) + prev, 0)
			setVoucherAmount(amount)
		} else {
			setVoucherAmount(data.amount)
		}
	}

	let total = cart.reduce((accumulator, currentValue) => accumulator + currentValue.price, 0) - voucherAmount;
	if (total < 0) {
		total = 0;
	}
	return (
		<div align="center" > <br /><br /><br /><br /><br /><br />
			SHOPPING CART
			<Grid container spacing={2} xs={12} sm={8} justify='center' direction="column" alignItems="stretch">
				<Grid item justify='center'>
					<TableContainer>
						<Table aria-label="simple table">
							<TableHead>
								<TableRow>
									<TableCell>Product</TableCell>
									<TableCell align="right">Quantity</TableCell>
									<TableCell align="right">Price</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{cart.map((item, i) => (
									<TableRow key={item.poster ? item.poster.labels.title : "mykey"}>
										<TableCell component="th" scope="row">
											{item.poster ? item.poster.labels.title : item.title} ({item.format}) <br />  <Link href="#" onClick={() => { console.log(i); dispatch(removeFromCart(i)) }}>
												Delete</Link>
										</TableCell>
										<TableCell align="right">1</TableCell>
										<TableCell align="right">${item.price}.00</TableCell>
									</TableRow>
								))}
								<TableRow>
									<TableCell colSpan={2}>
										<TextField
											id="Voucher"
											label="Voucher"
											value={voucher}
											onChange={(event) => { setVoucher(event.target.value) }}
											style={{ width: 100 }}
										/>
										<Button margin="normal" id="applyButton" variant="outlined" onClick={handleValidateVoucher} style={{ width: 130, marginTop: 10, marginLeft: 20 }}>Apply</Button >
									</TableCell>
									<TableCell align="right">{voucherAmount !== 0 ? "-$" + voucherAmount + '.00' : ''}</TableCell>
								</TableRow>
								<TableRow>
									<TableCell rowSpan={2} />
									<TableCell>Shipping fee</TableCell>
									<TableCell align="right">$0.00</TableCell>
								</TableRow>
								<TableRow>
									<TableCell>Total</TableCell>
									<TableCell align="right">${total}.00</TableCell>
								</TableRow>
							</TableBody>
						</Table>
					</TableContainer>
				</Grid>
				<Grid container justify='flex-end'>
					<Button margin="normal" id="applyButton" variant="contained" color="primary" onClick={() => { setCheckoutOpened(true) }}>Checkout</Button >
				</Grid>
			</Grid>

			<Dialog
				open={checkoutOpened}
				contentstyle={{ padding: 20 }}
				onClose={() => { setCheckoutOpened(false) }}
				fullWidth={true}
				maxWidth={cart.filter(item => item.format !== 'digital').length === 0 ? 'xs' : 'md'}
			>
				<DialogTitle id="alert-dialog-title" onClose={() => { setCheckoutOpened(false) }}>Checkout</DialogTitle>
				<DialogContent>
					<Elements stripe={global.stripePromise}>
						<ElementsConsumer>
							{({ elements, stripe }) => (
								<CheckoutForm elements={elements} stripe={stripe} title="{this.props.poster.labels.title}" format={cart.filter(item => item.format !== 'digital').length === 0 ? 'Digital' : 'Poster'} voucher={voucher} voucherAmount={voucherAmount} amount={total} />
							)}
						</ElementsConsumer>
					</Elements>
				</DialogContent>

			</Dialog>
		</div>
	)
}



// WEBPACK FOOTER //
// ./src/components/ShoppingCart.js